import { render, staticRenderFns } from "./InputCheckboxes.vue?vue&type=template&id=2067147e"
import script from "./InputCheckboxes.vue?vue&type=script&lang=js"
export * from "./InputCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports